// language-state.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { translationDictionary } from '../constants/translations';


export interface LanguageOption {
    code: string;
    label: string;
}

@Injectable({
    providedIn: 'root'
})
export class LanguageStateService {
    // Available languages
    public availableLanguages: LanguageOption[] = [
        { code: 'en', label: 'English' },
        { code: 'es', label: 'Spanish' }
    ];

    // Current language subject
    private currentLanguage = new BehaviorSubject<string>('en');
    public currentLanguage$ = this.currentLanguage.asObservable();

    // Translation dictionary is now imported from translations.ts
    private translationDictionary = translationDictionary;

    constructor() { }

    // Get current language
    getCurrentLanguage(): string {
        return this.currentLanguage.getValue();
    }

    // Set current language
    setLanguage(languageCode: string): void {
        if (this.translationDictionary[languageCode]) {
            this.currentLanguage.next(languageCode);
        }
    }

    // Get translation for a key
    getTranslation(key: string): string {
        const currentLang = this.getCurrentLanguage();
        const translations = this.translationDictionary[currentLang];
        return translations[key] || key;
    }

    // Method to get translations reactively
    getTranslation$(key: string): Observable<string> {
        return new Observable<string>(observer => {
            // Initial value
            observer.next(this.getTranslation(key));

            // Subscribe to language changes
            const subscription = this.currentLanguage$.subscribe(() => {
                observer.next(this.getTranslation(key));
            });

            // Clean up
            return () => subscription.unsubscribe();
        });
    }
}